module.exports = [{"type":"hash","text":"服務地址"},{"type":"code","text":"https://open-api.bingx.com"},{"type":"normal","text":"備用域名：open-api.bingx.io（總限頻：60/min）僅在主域名open-api.bingx.com出現問題時候才放開備用域名限頻"},{"type":"normal","text":"HTTP狀態碼200表示成功響應，併可能包含內容。如果響應含有內容，則将顯示在相應的返回內容裡面。"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/basic/01_server_url.json
// module id = FVkd
// module chunks = 3